module.exports = __webpack_public_path__ + "static/media/dashboard-logout.b6202046.svg";